<template>
    <div>
        <!-- Nothing. -->
    </div>
</template>

<!-- ################################################################## -->

<script>
    export default {
        name: 'BlankPage'
    }
</script>




// WEBPACK FOOTER //
// src/common/components/blank/BlankPage.vue